import React, {useState, useEffect} from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { configState } from "../../context/configState";
import { useLiquidity } from "../../hooks/useLiquidity";
import PoolHeader from "./PoolHeader";
import PoolList from "./PoolList";
import "./pools.css";
import { walletState } from "../../context/walletState";
import { pooolAprState, pooolMapState, pooolubondState, poooluliqState } from "../../context/pooolMapState";

const PoolListContainer = () => {

  const { poolsMap} = useRecoilValue(configState);
  const { client, address } = useRecoilValue(walletState);

    const { getPoolTotalAmount, getPoolAPR,getPoolUserAmount,
      getPoolUserBonded} = useLiquidity();

  // useEffect(() => {
  //   const getPools = async () => {
  //     const { totalAmount } = await getPoolTotalAmount(pol.pair_name);
  //     setTotalLiq(totalAmount);
  //     const poolAPR = await getPoolAPR(pol.pair_name);
  //     setPoolAPR(poolAPR.apr);
  //     console.log("apr", Number(poolAPR));
  //   };
  //   getPools();
  // }, [pol]);

  
  const [map, setMap] = useRecoilState(pooolMapState);
  const [aprmap, setaprMap] = useRecoilState(pooolAprState);
  const [userliqstatemap, setuserliqstateMap] = useRecoilState(poooluliqState);
  const [userbondstatemap, setuserbondstateMap] = useRecoilState(pooolubondState);

  let totalLiqMap: Record<string, number> = map;
  let userLiqMap: Record<string, number> = userliqstatemap;
  let userBondMap: Record<string, number> = userbondstatemap;
  let totalLiqAPR: Record<string, number> = aprmap;

  const [tLiqMp, setTLiqMp] = useState(totalLiqMap);
  const [uLiqMp, setULiqMp] = useState(userLiqMap);
  const [uBondMp, setUBondMp] = useState(userLiqMap);
  const [aprMp, setAprMp] = useState(totalLiqAPR);

  const keyData = Object.keys(map);
  const aprkeyData = Object.keys(aprMp);
  const userliqkeyData = Object.keys(userliqstatemap);
  const userbondkeyData = Object.keys(userbondstatemap);

  const fetchTliq = async (pol: any) => {

    const { totalAmount } = await getPoolTotalAmount(pol);
    if(!keyData.includes(pol) || Number(map[pol]) !== Number(totalAmount)){
      totalLiqMap[pol] =
      (totalAmount !== null && totalAmount !==undefined) ? (Number(totalAmount) ? Number(totalAmount) : 0) : -1;
      setMap(totalLiqMap);
    }
    const poolAPR = await getPoolAPR(pol);
      if(!aprkeyData.includes(pol) || Number(aprmap[pol]) !== Number(poolAPR.apr)){
      // if(!aprkeyData.includes(pol) ){
        totalLiqAPR[pol] =
        (poolAPR.apr !== null && poolAPR.apr !==undefined) ? (Number(poolAPR.apr) ? Number(poolAPR.apr) : 0) : -1;
        setaprMap(totalLiqAPR);
      }
  };

  const fetchUliq = async (pol: any) => {
    const { userAmount } = await getPoolUserAmount(pol);
    
    
    if(!userliqkeyData.includes(pol) || Number(userliqstatemap[pol]) !== Number(userAmount)){
      userLiqMap[pol] =
      (userAmount !== null  && userAmount !==undefined) ? (Number(userAmount) ? Number(userAmount) : 0) : -1;
      setuserliqstateMap(userLiqMap);
    }

    const { userDollarBonded } = await getPoolUserBonded(pol);
    if(!userbondkeyData.includes(pol) || Number(userbondstatemap[pol]) !== Number(userDollarBonded)){
      userBondMap[pol] =
        (userDollarBonded !== null && userDollarBonded !==undefined) ? (Number(userDollarBonded) ? Number(userDollarBonded) : 0) : -1;
        setuserbondstateMap(userBondMap);
    }
  };

  let poools = Object.keys(poolsMap);

  const fetchTdataa = async() =>{
    poools.map(async(pol) => {
      await fetchTliq(pol);
      // setTLiqMp(totalLiqMap);
      // setAprMp(totalLiqAPR);
      // console.log(uLiqMp, uBondMp, tLiqMp, aprMp);
    });
  }

  const fetchUdataa = async() =>{
    poools.map(async(pol) => {
      await fetchUliq(pol);
      // setULiqMp(userLiqMap);
      // setUBondMp(userBondMap);
      // console.log(uLiqMp, uBondMp, tLiqMp, aprMp);
    });
  }

  useEffect(() => {
    fetchTdataa();
    fetchUdataa();
  }, [client, address]);
  // }, [sortKey, sortOrder]);

  return (
    <div className="pool-list-container">
        <div className="pool-list-header">
        <PoolHeader />
        </div>
        <div className="">
        <PoolList tLiqMp={map} aprMp={aprmap} uBondMp={userbondstatemap} uLiqMp={userliqstatemap}/>
        </div>
    </div>
  );
};

export default PoolListContainer;
